import React from 'react';
import Alert from '@material-ui/lab/Alert';

export default function UnauthorizedAlert () {
  return <Alert severity="warning">You are not authorized to use this function!</Alert>;
}
